import { logger } from '@this/shared/dist/tools/logger.js';
import { toast } from 'sonner';
export function trackException(error, silent = false) {
    // prepare a hopefully human readable message
    let message = (error.message || error) + '';
    if (error.response) {
        message += ` - ${error.response.status} ${error.response.statusText}`;
    }
    // show it to the devs
    if (error.stack) {
        logger.error(message);
        logger.error(error.stack);
    }
    else {
        logger.trace(message);
    }
    // show it to the user
    if (!silent) {
        toast.error(message, { id: message });
    }
    // report it to insights
    window.appInsights?.trackException({
        exception: error instanceof Error ? error : new Error(message),
    });
}
export function trackEvent(name) {
    logger.debug(`[Event] ${name}`);
    window.appInsights?.trackEvent({
        name,
    });
}
